/**
 * Form Tracking sidebar configuration
 */
export default {
  pathPrefix: 'form_tracking',
  items: [
    {
      label: 'Widgets',
      href: '/form_tracking/widgets',
      icon: 'fa-solid fa-code',
      activePath: 'form_tracking/widgets'
    },
    {
      label: 'Submits',
      href: '/form_tracking/submits',
      icon: 'fa-solid fa-upload',
      activePath: 'form_tracking/submits'
    }
  ]
}
